import client from '../client'

export const getFinancialPreferencesKey = `${process.env.NEXT_PUBLIC_PURCHASE_DOMAIN}/api/UserAccounts/GetFinancialPreferences`

export async function getFinancialPreferences() {
  return client(getFinancialPreferencesKey)
}
